
  declare var window: any;
  export default {
    props: {
      instructions: String
    },
    data() {
      window.wf ??= {};
      let d = window.wf.CareerListings;
      d.sortDescending = false;
      d.selectedLocation ??= '';
      d.selectedJobType ??= '';
      d.selectedJobCategory ??= '';
      d.pageSize ??= 10;
      d.pageNumber = 1;
      return d;
    },
    created() {
      this.resetFilters();
    },
    methods: {
      resetFilters() {
        this.sortDescending = false;
        this.selectedLocation = '';
        this.selectedJobType = '';
        this.selectedJobCategory = '';
        this.currentPage = 1;
      },
      updateFilters() {
        var tempFilteredJobs = this.filteredJobs;
      },
      setPage(index) {
        this.pageNumber = index;
      }
    },
    computed: {
      filteredJobs() {
        var tempFilteredJobs = [...this.jobs];

        if (this.selectedLocation != '') {
          tempFilteredJobs = tempFilteredJobs.filter(el => el.locations.includes(this.selectedLocation))
        }

        if (this.selectedJobType != '') {
          tempFilteredJobs = tempFilteredJobs.filter(el => el.jobtypes.includes(this.selectedJobType));
        }

        if (this.selectedJobCategory != '') {
          tempFilteredJobs = tempFilteredJobs.filter(el => el.jobcategories.includes(this.selectedJobCategory));
        }

        return tempFilteredJobs;
      },
      orderedJobs() {
        var tempOrderedJobs = [...this.filteredJobs];
        if (this.sortDescending) {
          return tempOrderedJobs.sort((a, b) => a.jobposting.toLowerCase().localeCompare(b.jobposting.toLowerCase())).reverse();
        }
        return tempOrderedJobs.sort((a, b) => a.jobposting.toLowerCase().localeCompare(b.jobposting.toLowerCase()));
      },
      paginatedJobs() {
        const start = (this.pageNumber - 1) * this.pageSize
        const end = start + this.pageSize
        return this.orderedJobs.slice(start, end)
      },
      pageCount() {
        return Math.ceil(this.orderedJobs.length / this.pageSize);
      }
    }
  }
